import { ref, computed } from 'vue'
import { InitialReview, AcceptReview, RejectReview } from '@/components/booking-manager/artist/advance-step/review-set'

const _editSetDetails = [
    {
        identifier: 'review-details-step-initial',
        title: 'Set details have changed',
        set: null,
        component: InitialReview
    },
    {
        identifier: 'review-details-step-accept',
        title: 'Set details have changed',
        set: null,
        component: AcceptReview
    },
    {
        identifier: 'review-details-step-reject',
        title: 'Set details have changed',
        set: null,
        component: RejectReview
    }
]

const _editSetPayout = [
    {
        identifier: 'review-payout-step-initial',
        title: 'Payout has changed',
        set: null,
        component: InitialReview
    },
    {
        identifier: 'review-payout-step-accept',
        title: 'Payout has changed',
        set: null,
        component: AcceptReview
    },
    {
        identifier: 'review-payout-step-reject',
        title: 'Payout has changed',
        set: null,
        component: RejectReview
    }
]

export const useReviewSetSteps = (mode) => {
    const step = ref(0)

    const steps = computed(() => {
        switch (mode.value) {
            case 'details':
                return _editSetDetails
            case 'payout':
                return _editSetPayout
            default:
                return []
        }
    })
    const currentStep = computed(() => steps.value[step.value])

    const findStep = (id) => {
        return steps.value.find((step) => step.identifier === `review-${mode.value}-step-${id}`)
    }
    const updateStep = (id) => {
        step.value = steps.value.indexOf(findStep(id))
    }

    return {
        step,
        steps,
        currentStep,
        findStep,
        updateStep
    }
}
